function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMushrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DCB2"
    },
    d: "M399.347,447.953l-5.592-68.02l-2.849-34.607l-0.225-2.294 c-15.169,1.608-184.965-88.746-174.797-102.568c-18.184-0.414-35.683-1.454-52.2-3.216l-0.13,3.37l-3.192,38.828l-9.08,110.218 c-0.355,3.18-0.532,6.337-0.532,9.459c0,45.544,36.995,83.556,83.71,83.556c19.308,0,36.96-6.503,51.018-17.345 C290.56,491.652,313.71,512,342.074,512C376.445,512,403.178,482.111,399.347,447.953z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDBB8E"
    },
    d: "M189.763,399.122c0-3.121,0.177-6.278,0.532-9.459l8.833-107.217 c0.087,0.004,0.174,0.009,0.261,0.013c0.414-13.561,63.586-15.867,73.754-29.689c-4.474-0.102-57.686-28.198-62.073-28.376 c0,0-9.424-1.612-12.415-1.774c-0.657-0.035-31.923-2.365-34.974,14.626l-0.13,3.37l-3.192,38.828l-9.08,110.218 c-0.355,3.18-0.532,6.337-0.532,9.459c0,45.544,36.995,83.556,83.71,83.556c6.737,0,13.267-0.809,19.518-2.3 C216.875,471.544,189.763,438.104,189.763,399.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDBB8E"
    },
    d: "M323.904,382.32c5.952,0.197,12.014,0.297,18.17,0.297c17.073,0,33.437-0.733,48.606-2.341 c1.029-0.106,2.057-0.225,3.074-0.343l-2.849-34.607l-0.225-2.294c-8.761-14.59-42.458-29.369-42.458-29.369 c-5.769-0.157-40.791,11.232-54.742,29.369l-0.225,2.294l-2.849,34.607l-5.604,68.02c-0.248,2.187-0.367,4.363-0.367,6.503 c0,3.713,0.355,7.354,1.04,10.878C290.56,491.652,313.71,512,342.074,512c5.875,0,11.52-0.891,16.834-2.511 c-20.327-6.201-35.708-23.298-39.737-44.156c-0.686-3.523-1.04-7.165-1.04-10.878c0-2.14,0.118-4.316,0.367-6.503L323.904,382.32z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B27214"
    },
    d: "M419.506,199.295c14.2-12.497,22.204-28.234,22.204-47.755C441.71,85.081,348.92,0,234.458,0 S27.206,85.081,27.206,151.54c0,52.035,56.859,77.219,136.477,85.708c16.517,1.762,34.016,2.802,52.2,3.216 c-10.546,14.342-16.517,29.535-16.517,43.522c0,35.86,39.218,53.205,94.114,59.046c15.169,1.608,31.533,2.341,48.594,2.341 c17.073,0,33.437-0.733,48.606-2.341c54.896-5.841,94.114-23.186,94.114-59.046C484.794,254.794,458.795,220.376,419.506,199.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#995C0D"
    },
    d: "M250.795,283.986c0-13.987,5.971-29.18,16.517-43.522c20.093-27.359,56.824-51.65,100.483-58.742 c-8.344-1.356-16.939-2.089-25.721-2.089c-52.256,0-97.932,25.754-122.786,56.445c0.001-0.001,0.002-0.002,0.004-0.004 c-74.331-9.504-126.469-34.706-126.469-84.534c0-59.977,75.574-135.108,174.443-149.198C256.579,0.819,245.624,0,234.458,0 C119.996,0,27.206,85.081,27.206,151.54c0,52.035,56.859,77.219,136.477,85.708c16.517,1.762,34.016,2.802,52.2,3.216 c0.584-0.796,1.189-1.587,1.807-2.375c-0.612,0.79-1.221,1.58-1.805,2.375c-10.546,14.342-16.517,29.535-16.517,43.522 c0,35.86,39.218,53.205,94.114,59.046c15.169,1.608,31.533,2.341,48.594,2.341c8.785,0,17.377-0.197,25.719-0.605 c-7.87-0.384-15.521-0.955-22.885-1.736C290.014,337.191,250.795,319.846,250.795,283.986z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushrooms);
export default __webpack_public_path__ + "static/media/mushrooms.b350e85bafffd07c2b5047abb1edf6bf.svg";
export { ForwardRef as ReactComponent };